import { gspx } from '@rsos/capstone';

export const trackPushNotificationEnabled = irpVersion => {
  gspx.trackCustomEvent('Push Notification', {
    irpVersion,
    name: `User granted push notification`,
    Category: 'Push Notification',
    'Launched date': new Date(),
  });
};
export const trackPushNotificationDenied = irpVersion => {
  gspx.trackCustomEvent('Push Notification', {
    irpVersion,
    name: `User denied push notification`,
    Category: 'Push Notification',
    'Launched date': new Date(),
  });
};
